<template>
  <div>
    <ubi-panel>
      <ubi-form-group :title="$t('posts.offerTitle')">
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item :label="$labels.offre_titre" prop="offre_titre">
              <el-input :placeholder="$t('validator.offerTitleMax', {number: 70})" v-model.number="post.offre_titre"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <div></div>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('posts.offerDetail')">
              <el-input :rows="2" type="textarea" v-model="post.offre_texte"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$labels.offre_mentions_legales">
              <el-input v-model.number="post.offre_mentions_legales"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$labels.offre_type">
              <el-input v-model.number="post.offre_type" :disabled="desactiverChamp"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="block">
              <el-form-item :label="$labels.offre_date_debut">
                <el-date-picker format="dd/MM/yyyy" value-format="dd/MM/yyyy" v-model="post.offre_date_debut"></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="block">
              <el-form-item :label="$labels.offre_date_fin">
                <el-date-picker format="dd/MM/yyyy" value-format="dd/MM/yyyy" v-model="post.offre_date_fin"></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </ubi-form-group>
    </ubi-panel>
  </div>
</template>
<script>

import UbiPanel from '../../../../components/Panel'
export default {
  name: 'OffreCommerciale',
  components: { UbiPanel },
  props: ['post', 'desactiverChamp'],
  data () {
    return {}
  }
}
</script>

<style>

</style>
